import { Component, OnDestroy, OnInit, input, output } from '@angular/core';
import { UntypedFormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { filter, map, Subscription, tap } from 'rxjs';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';

@Component({
    selector: 'app-multi-select-prop-filter[formName][values]',
    template: `
  <form [formGroup]="formGroup()">
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>{{formName()}}</mat-label>
      <mat-select [formControlName]="formName()" multiple>
        @for (value of values(); track value) {
          <mat-option [value]="value">{{value}}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </form>
  `,
    styles: [],
    imports: [FormsModule, ReactiveFormsModule, MatFormField, MatLabel, MatSelect, MatOption]
})
export class MultiSelectPropFilterComponent implements OnInit, OnDestroy {

  readonly formName = input<any>();

  readonly formGroup = input.required<UntypedFormGroup>();
  
  readonly values = input<any>([]);

  readonly changes = output<any>();

  private sub: Subscription | undefined;
  
  constructor() { }

  ngOnInit(): void {
    const valuesChangeSub = this.formGroup().get(this.formName())?.valueChanges.pipe(
      filter(vals => !!vals),
      map(values => {
        if(values.length !== 0) {
          // "field": {"$in": ["value1", "value2"]
          const vals = values.map((v: string) => `"${v}"`).join(',');
          return {
            [this.formName()]: `{"$in":[${vals}]}`
          }
        } else {
          return '';
        }
      }),
      tap(predicate => this.changes.emit(predicate))
    ).subscribe();

    this.sub = valuesChangeSub;
  }

 
  ngOnDestroy(): void {
    this.sub?.unsubscribe()
  }


}
